package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_04_12_Day_1
import com.veldekar.components.logs.Log_2024_04_12_Day_2
import com.veldekar.components.logs.Log_2024_04_12_Day_3
import com.veldekar.components.logs.Log_2024_04_12_Day_4
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-04-12")
@Composable
public fun Log_2024_04_12(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Arrival in Zedj",
        ogTitle = "Arrival in Zedj",
        date = LocalDate(2_024, 4, 12),
        ogDescription = "The heroes reach Zedj and learn of a dragon landing nearby, while Tuesday chats with a local raccoon named Dax.",
        ogImage = "ai/2024-04-12.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-47", dateString = "Newgrowth 47")
        Log_2024_04_12_Day_1()
        SessionDayHeader(dayId = "newgrowth-49", dateString = "Newgrowth 49")
        Log_2024_04_12_Day_2()
        SessionDayHeader(dayId = "newgrowth-50", dateString = "Newgrowth 50")
        Log_2024_04_12_Day_3()
        SessionDayHeader(dayId = "newgrowth-51", dateString = "Newgrowth 51")
        Log_2024_04_12_Day_4()
        SessionMediaItem(
            image = "images/Footseller_Note.webp",
            linkImage = "images/Footseller_Note.webp",
            invertForDarkMode = true,
            ocrText = "Newgrowth 31, 2401 Master Footseller, This contract is of immediate and utmost importance. A sum of 10,000 gp shall be placed in your name upon successful proven completion of its terms, and as such the death of Annette Dazzlecraft must be pursued with alacrity. With authority, the MonCon",
            description = "Evidence of a contract to kill Annette Dazzlecraft.",
            width = 1_538,
            height = 2_230,
        )
    }
}
